/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllQuotes: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.VIEW ALL QUOTES',
        defaultMessage: 'VIEW ALL QUOTES'
    },
    noQuotesToShow: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.No quotes to show',
        defaultMessage: 'No quotes to show'
    },
    quoteCreated: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.QUOTE CREATED',
        defaultMessage: 'QUOTE CREATED'
    },
    customerName: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    quoteNumber: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.QUOTE NUMBER',
        defaultMessage: 'QUOTE NUMBER'
    },
    bundle: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.BUNDLE',
        defaultMessage: 'BUNDLE'
    },
    policyType: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.POLICY TYPE',
        defaultMessage: 'POLICY TYPE'
    },
    initiator: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.INITIATOR',
        defaultMessage: 'INITIATOR'
    },
    change: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.CHANGE',
        defaultMessage: 'CHANGE'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    quoteToCompleteInPC: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Quote has not been completed. The quote must be completed in PolicyCenter.',
        defaultMessage: 'Quote has not been completed. The quote must be completed in PolicyCenter.'
    },
    quoteNotCompleteCall: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Quote has not been completed. Contact us at 1-800-255-0332 for assistance.',
        defaultMessage: 'Quote has not been completed. Contact us at 1-800-255-0332 for assistance.'
    },
    contactBookManager: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Quote has not been completed. Please contact your Book Consolidation manager.',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    quoteNotComplete: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Quote is not complete',
        defaultMessage: 'Quote is not complete'
    },
    choiceAgent: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Choice Agent',
        defaultMessage: 'Choice Agent'
    },
    recentQuotes: {
        id: 'ml.gateway.views.ActivityReports.MLQuotesReportComponent.Recent Quotes',
        defaultMessage: 'Recent Quotes'
    }
});
